module.exports = __webpack_public_path__ + "static/sport/bg1.8c051c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ldp/bg1.png
// module id = +8U3
// module chunks = 0